"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
exports.range = exports.noop = exports.isValidNumericValue = exports.isTouchDevice = exports.isEmpty = exports.getViewport = exports.getIntegersCount = exports.getDecimalsCount = void 0;
const getViewport = () => ({
  height: window.innerHeight || document.documentElement.offsetHeight,
  width: window.innerWidth || document.documentElement.offsetWidth
});
exports.getViewport = getViewport;
const range = (start = 0, stop = null, step = 1) => {
  let [_start, _stop] = [0, start];
  if (stop !== null) {
    [_start, _stop] = [start, stop];
  }
  const length = Math.max(Math.ceil((_stop - _start) / step), 0);
  const _range = Array(length);
  for (let idx = 0; idx < length; idx += 1, _start += step) {
    _range[idx] = _start;
  }
  return _range;
};
exports.range = range;
const isEmpty = obj => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};
exports.isEmpty = isEmpty;
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
const getDecimalsCount = value => {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
};
exports.getDecimalsCount = getDecimalsCount;
const getIntegersCount = value => {
  if (Math.floor(value) === value) return value.toString().length;
  return value.toString().split('.')[0].length || 1;
};
exports.getIntegersCount = getIntegersCount;
const isTouchDevice = exports.isTouchDevice = 'ontouchstart' in window;
const noop = () => {};
exports.noop = noop;
const isValidNumericValue = value => {
  return typeof value === 'number' && !Number.isNaN(value);
};
exports.isValidNumericValue = isValidNumericValue;